export function shouldResetDeckAfterCardAppend(
  previousCardsLength: number,
  cardsLength: number,
  cardIndex: number,
): boolean {
  return cardsLength > previousCardsLength && cardIndex >= 0 && cardIndex < cardsLength;
}
